<template>
  <div class="flex flex-col">
    <modal size="sm" v-model="showModalErros" v-if="modalError" :autoclose="false">
      <template v-slot:body>
        <div>
          <ul>
            <li v-for="(row, index) in validos" :key="index" class="items-center grid grid-cols-modalFileShowError">
              <span>
                <font-awesome-icon icon="check-circle" v-if="row.state"
                                   class="text-green-500 text-xl"></font-awesome-icon>
                <font-awesome-icon icon="times-circle" v-else class="text-red-500 text-xl"></font-awesome-icon>
              </span>
              <span> {{ row.name }}: </span>
              <span>{{ row.message }}</span>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button @click="showModalErros=false">Ok</button>
        </div>
      </template>
    </modal>
    <slot name="button">
      <button @click="abrirFile()"
              class="border focus:outline-none px-8 py-1 rounded-md"
              :class="value && value.length>0?'border-green-500 text-green-500':
            showMessage?'border-red-500 text-red-500':'border-blue-500 text-blue-500'">
        {{
          value && value.length > 0 ? `${value.length} archivo${value.length > 1 ? 's' : ''}` : inputLabel
        }}
      </button>
    </slot>
    <span class="text-red-500 text-xs" v-show="showMessage">{{ message }}</span>
    <input type="file" style="display: none" ref="archivo" :multiple="multiple"
           @input="asignarArchivo($event)" :accept="accept"/>
  </div>
</template>

<script>
export default {
  name: "input-complete-file",
  props: {
    inputLabel:{
      type:String,
      default:()=>'Seleccionar'
    },
    reglas: {
      type: Array
    },
    accept: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: null
    },
    modalError: {
      type: Boolean,
      default: () => true
    },
    value: null,
    validaciones: {
      type: Boolean,
      default: () => true
    }
  },
  data: () => ({
    message: null,
    showMessage: false,
    validos: [],
    showModalErros: false
  }),
  methods: {
    abrirFile() {
      this.$refs.archivo.click()
    },
    validSize(size, megas = 50) {
      //megas equivale a la cantidad de megas maximo
      return (size / 1048576) <= megas
    },
    buscarMegas(type) {
      return this.reglas.find(rule => {
        let subRules = rule.type.split(',')
        return subRules.find(subrule => subrule === type)
      })
    },
    asignarArchivo(file) {
      let files = file.target.files
      if(this.validaciones){
        this.showModalErros = false
        this.showMessage = null
        this.validos = []
        this.showMessage = false
        let guardar = true
        if ((this.multiple && this.max && files.length <= this.max) || (this.multiple && !this.max) || (!this.multiple && files.length === 1)) {
          files.forEach(file => {
            let propiedades = file.type ? this.buscarMegas(file.type) : this.buscarMegas('.'+file.name.split('.').pop())//saca los megas permitidos para el tipo de archivo
            if (propiedades) {
              let megas = propiedades.limite_maximo_mb
              if (this.validSize(file.size, megas)) {
                if (files.length > 1) {
                  this.validos.push({
                    name: file.name,
                    message: 'Valido',
                    state: true
                  })
                }
              } else {
                if (files.length === 1) {
                  this.$emit('error', {
                    name: file.name,
                    message: `Megas maximo ${megas}`,
                    state: false
                  })
                  this.message = `Megas maximo ${megas}`
                  this.showMessage = true
                } else {
                  this.validos.push({
                    name: file.name,
                    message: `Excede la cantidad de ${megas} megas permitidas`,
                    state: false
                  })
                }
                guardar = false
              }
            } else {
              if (files.length === 1) {
                this.message = `tipo de archivo no valido`
                this.showMessage = true
                this.$emit('error', {
                  name: file.name,
                  message: `tipo de archivo no valido`,
                  state: false
                })
              } else {
                this.validos.push({
                  name: file.name,
                  message: 'Tipo de archivo no valido',
                  state: false
                })
              }
              guardar = false
            }
          })
        } else {
          guardar = false
          this.message = `${this.max} archivos permitidos`
          this.showMessage = true
        }
        if (guardar) {
          this.$emit("input", files)
          this.$emit("change", files)
          this.message = null
          this.showMessage = false
        } else {
          if (this.validos.length > 0) {
            this.showModalErros = true
            this.$emit('error', this.validos)
          }
          this.$emit("input", null)
        }
      }else{
        this.$emit("input", files)
        this.$emit("change", files)
      }
    },
  }
}
</script>

<style scoped>

</style>
